import styled from "styled-components";
import {mediaScreenSizes} from "../../../utils/constans/styles/screenSizes";

export interface AuthPageCardProps {
  $maxWidth?: number;
  $formAtBottom?: boolean;
}

/**
 * Shared card wrapper for Login and Register pages.
 * - $maxWidth: max width in px (default 400, use 600 for Register)
 * - $formAtBottom: when true (Login), form is pushed to bottom with flexible gap; when false (Register), content flows normally for full-page scroll
 */
export const AuthPageCard = styled.div<AuthPageCardProps>`
  width: 100%;
  max-width: ${(p) => p.$maxWidth ?? 400}px;

  @media (max-width: ${mediaScreenSizes.mobile}) {
    max-width: 100%;
    padding: 0 24px;
    ${(p) => (p.$formAtBottom ? "min-height: 100%; display: flex; flex-direction: column;" : "")}
    background: #fff;
    overflow: visible !important;

    .ant-card {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      ${(p) => (p.$formAtBottom ? "flex: 1; display: flex; flex-direction: column;" : "")}
      overflow: visible !important;
    }

    .ant-card-body {
      background: transparent !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      ${(p) => (p.$formAtBottom ? "margin-top: 0; flex: 0 0 auto;" : "")}
      padding-bottom: 96px !important;
      overflow: visible !important;
    }

    .ant-card-head {
      background: transparent !important;
      border: none !important;
      padding: 0 0 24px 0 !important;
      ${(p) =>
        p.$formAtBottom
          ? `
        flex: 1 1 0;
        min-height: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      `
          : ""}
    }

    .auth-logo-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .auth-logo-wrap svg {
      width: 200px;
      height: auto;
    }

    .auth-subtitle {
      display: none !important;
    }
  }
`;

/**
 * Shared form wrapper for Login and Register.
 * Use class names: auth-subtitle, auth-actions-row, auth-submit-wrap, auth-logo-wrap
 */
export const AuthFormWrapper = styled.div`
  width: 100%;

  .auth-subtitle {
    margin-bottom: 20px;
  }

  @media (max-width: ${mediaScreenSizes.mobile}) {
    overflow: visible !important;
    touch-action: pan-y;

    .ant-form {
      overflow: visible !important;
    }

    .ant-form-item {
      margin-bottom: 28px;
    }

    .ant-form-item-label {
      padding-bottom: 2px !important;
    }

    .ant-form-item-control {
      min-height: 0 !important;
    }

    .ant-form-item-control-input {
      min-height: 0 !important;
    }

    .ant-form-item-control-input-content {
      min-height: 0 !important;
    }

    .ant-form-item-explain,
    .ant-form-item-explain-connected {
      min-height: 0 !important;
      margin-top: 0 !important;
    }

    .ant-form-item-explain-error {
      min-height: 0 !important;
    }

    .ant-form-item-label > label {
      font-size: 16px !important;
      font-weight: 500;
      height: auto !important;
      line-height: 1.4 !important;
    }

    .ant-input {
      min-height: 48px !important;
      padding: 14px 0 !important;
      font-size: 16px !important;
      background: transparent !important;
      border-radius: 0 !important;
      border-left: none !important;
      border-right: none !important;
      border-top: none !important;
      border-bottom: 1px solid #d9d9d9 !important;
    }

    .ant-input-password {
      min-height: 48px !important;
      padding: 3px 0 !important;
      background: transparent !important;
      border-radius: 0 !important;
      border-left: none !important;
      border-right: none !important;
      border-top: none !important;
      border-bottom: 1px solid #d9d9d9 !important;
    }

    .ant-input-password .ant-input-affix-wrapper {
      min-height: 0 !important;
      height: 48px !important;
      padding: 0 !important;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      align-items: center !important;
    }

    .ant-input-password .ant-input-suffix {
      margin-inline-start: 0 !important;
    }

    .ant-input-password input {
      min-height: 48px !important;
      height: 48px !important;
      padding: 0 0 0 0 !important;
      font-size: 16px !important;
      background: transparent !important;
      border: none !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    .ant-input-affix-wrapper-focused,
    .ant-input-password:focus-within,
    .ant-input:focus {
      border-color: #1890ff !important;
      box-shadow: none !important;
    }

    .auth-actions-row {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
      margin-top: 8px;
    }

    .auth-actions-row .ant-col {
      max-width: 100%;
      text-align: center;
    }

    .auth-actions-row .ant-btn-link {
      display: block;
      padding: 12px;
      font-size: 15px;
      width: 100%;
    }

    .auth-submit-wrap .ant-btn {
      min-height: 48px !important;
      font-size: 16px;
      border-radius: 12px;
    }
  }
`;
